module.exports = __webpack_public_path__ + "img/131w.c08bf7e.jpg";